// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__3KoIl","withIcon":"Title_withIcon__288t3","titleIconWrapper":"Title_titleIconWrapper__2Gsn1","icon":"Title_icon__24brz"};